import { resolveDomain, RestClient } from '../../../utils'
import { API_AUTH_BASE_PATH, API_AUTH_SIGNIN } from '../constants'
import { SignInHandlerParametersInterface } from './types'

const client = new RestClient(`${API_AUTH_BASE_PATH}/${API_AUTH_SIGNIN}`, {}, resolveDomain(), {
  mode: 'cors',
  referrerPolicy: 'no-referrer',
})

export const signInHandler = async (user: SignInHandlerParametersInterface) => {
  const body = new FormData()

  for (const key of Object.keys(user)) {
    body.append(key, user[key as keyof SignInHandlerParametersInterface] as string)
  }

  await client.post<null, void>('', null, null, { body })
}
